
/**
 * Domain detection utilities - simplified version
 */

export const getBaseUrl = (): string => {
  return window.location.origin;
};

export const getAbsoluteUrl = (path: string): string => {
  return `${getBaseUrl()}${path.startsWith('/') ? '' : '/'}${path}`;
};

// Always return false to prevent domain-based redirects
export const isPublicDomain = (): boolean => {
  return false;
};

// Simplified redirect function that just logs instead of redirecting
export const redirectToLogin = (): void => {
  console.log('Redirect to login requested but disabled');
};

// Additional helper functions for debugging and control
export const clearRedirectionFlags = (): void => {
  try {
    console.log('Clearing all redirection flags');
    sessionStorage.removeItem('cs_redirect_count');
    sessionStorage.removeItem('cs_redirect_disabled');
  } catch (e) {
    console.warn('Failed to clear redirection flags', e);
  }
};

// Add explicit helper to disable redirects for testing
export const disableRedirects = (): void => {
  try {
    console.log('Manually disabling all redirects');
    sessionStorage.setItem('cs_redirect_disabled', 'true');
  } catch (e) {
    console.warn('Failed to disable redirects', e);
  }
};

// Add helper to enable redirects
export const enableRedirects = (): void => {
  try {
    console.log('Enabling redirects');
    sessionStorage.removeItem('cs_redirect_disabled');
  } catch (e) {
    console.warn('Failed to enable redirects', e);
  }
};
